import React, { useState, useEffect } from "react";
import { Wrapper } from "../../components";
import Sidebar from "../../components/NewSidebar";
import { AnalyticsComponent } from "../../components/Analytics/Analytics";
import ReferralsComponent from "../../components/Referrals";
import { isUserLoggedIn } from "../../utils/helpers";
import { useSearchParams } from "react-router-dom";
import { useIfUserEligible } from "../../hooks/useIfUserEligible";
import { FEATURES } from "../../constants/features";

const options = {
  referrals: {
    title: "Referrals",
    component: <ReferralsComponent />,
  },
  analytics: {
    title: "Analytics",
    component: <AnalyticsComponent />,
  },
};

const Referrals = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { isInReferralProgram, isCheckingEligibility } = useIfUserEligible(
    FEATURES.REFFERAL_PROGRAM,
  );

  // Get tab from URL params, default to 'referrals'
  const getCurrentTab = () => {
    const tab = searchParams.get("tab");
    return tab && options[tab] ? tab : "referrals";
  };

  const [selectedIndex, setSelectedIndex] = useState(getCurrentTab());

  // Update selectedIndex when URL params change
  useEffect(() => {
    setSelectedIndex(getCurrentTab());
  }, [searchParams]);

  const onChangeIndex = (index) => {
    const tabKey = options[index] ? index : "referrals";
    setSelectedIndex(tabKey);

    // Update URL with tab parameter
    const newSearchParams = new URLSearchParams(searchParams);
    if (tabKey === "referrals") {
      newSearchParams.delete("tab"); // Remove tab param for default referrals tab
    } else {
      newSearchParams.set("tab", tabKey);
    }
    setSearchParams(newSearchParams);
  };

  if (!isCheckingEligibility && !isInReferralProgram) {
    return (
      <Wrapper
        fullSize
        isUserProfile={isUserLoggedIn}
        centerContent={<AnalyticsComponent />}
      />
    );
  }

  return (
    <Wrapper
      leftContent={
        <Sidebar
          title="Earnings Program"
          options={options}
          selectedIndex={selectedIndex}
          setSelectedIndex={onChangeIndex}
        />
      }
      isUserProfile={isUserLoggedIn}
      centerContent={options[selectedIndex]?.component}
    />
  );
};

export default Referrals;
